import { getClient } from '@api/client';
import { graphql } from '@api/generated';

const getServiceQueuesQuery = graphql(`
  query getServiceQueuesQuery {
    queues {
      items {
        id
        entrypoints
        name
        status {
          activeRecipientCount
          availableRecipientCount
          estimatedWait
          averageWait
          longestWait
          recipientCount
          activeSessionCount
          totalSessions
          missedSessions
          abandonedSessions
        }
        memberIds
        sessions {
          id
          name
          position
          enteredAt
        }
        inboundRecording
        outboundRecording
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`);

async function getServiceQueues() {
  const { data, error } = await getClient().query({
    query: getServiceQueuesQuery,
    fetchPolicy: 'network-only',
  });

  if (error) {
    throw new Error(error.message);
  }

  return data?.queues?.items ?? [];
}

export default getServiceQueues;
